export const initializeAmplitude = () => {

    const isProduction = process.env.VUE_ADM_PAGE === 'https://adm.voompcreators.com.br';

    if (!isProduction) {
        return;
    }

    const amplitudeScript = document.createElement('script');
    amplitudeScript.src = 'https://cdn.amplitude.com/script/763cfca92b01e4c1ce8b5cd35aae785a.js';
    amplitudeScript.onload = () => {
        if (window.amplitude) {
            window.amplitude.add(window.sessionReplay.plugin({sampleRate: 1}));
            window.amplitude.init('763cfca92b01e4c1ce8b5cd35aae785a', {
                "fetchRemoteConfig": true,
                "autocapture": true
            });
            console.log('Amplitude initialized successfully.', window.amplitude);
        }
    };
    
    document.head.appendChild(amplitudeScript);
}; 